import React from 'react';
import { Card, Button } from 'antd';

import styles from './styles.module.scss';

function getTitleLabel (id) {
  if (id) {
    return id === 'new'
      ? 'Créer un agent'
      : 'Éditer un agent';
  }
  return 'Liste des agents';
}

export const UsersCard = ({ id, actionLabel, action, children }) => (
  <Card
    className={styles.userCard}
    title={getTitleLabel(id)}
    extra={actionLabel && (
      <Button
        onClick={action}
      >
        {actionLabel}
      </Button>
    )}
  >
    {children}
  </Card>
);

export default UsersCard;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UsersCard/index.js